<template>
  <a
    class="navbar-item is-desktop-icon-only"
    title="Deconectare"
    @click="logout"
  >Deconectare
  </a>
</template>

<script>
export default {
  name: 'LogoutButton',
  methods: {
    logout () {
      this.$auth.logout({
        returnTo: window.location.origin,
        clientID: 'e0fYaM1NSFRY903lq23X5CBGRWCZsMrB'
      })
    }
  }
}
</script>
